import React from 'react'
import PropTypes from 'prop-types'
import Dropzone from 'react-dropzone'
import './MultiImageUpload.css'
import axios from 'axios'
import {s3new} from '../../api'
import loader from './loader.gif'
import plus from './plus.png'
import SimpleInfoModal from '../../SimpleInfoModal'
import ImagePreview from '../ImagePreview'
import * as mpOauthForm from '../../mixpanel/oauth/form'

class RFMultiImageUpload extends React.Component {
  static WAIT_FOR_FILE = 'wait_for_file'
  static LOADING = 'loading'
  static SHOW_INFO_MODAL = 'show_info_modal'

  constructor (props) {
    super(props)
    this.state = {
      act: RFMultiImageUpload.WAIT_FOR_FILE
    }
  }

  componentDidMount() {
    this._scrollImageContainerToRight()
  }

  render () {
    const {name, dropzoneClassName, fields, meta} = this.props
    return <div>
      <Dropzone
        multiple
        onDrop={this._onDrop}
        className={`fields-multi-image-upload__dropzone ${dropzoneClassName}`}
        disabled={this.state.act !== RFMultiImageUpload.WAIT_FOR_FILE}
      >
        <div className='fields-multi-image-upload__container' ref={(dom) => {this._imageScrollableDOM = dom}}>
          <div className='fields-multi-image-upload__text_container'>
            {fields.length === 0 && (this.state.act !== RFMultiImageUpload.LOADING) && <div className='fields-multi-image-upload__drag_drop_info'>
              <h3 className='mb-20px'><span className='fw-500'>Drag & drop</span><span className='fw-400 ml-10px'>your screenshots</span></h3>
              <p className='mb-30px' style={{color:'#aeaeae',fontSize:'14px'}}>or simply</p>
              <button type='button' className='btn btn-primary p l-35px pr-35px' style={{background: '#4a90e2'}} onClick={this._screenshotUpload}>Browse Your Computer</button>
            </div>}
          </div>


          <div className='fields-multi-image-upload__image_container'>
            {fields.length > 0 && fields.map((member, idx, fields) => {
              return <ImagePreview
                image={fields.get(idx).image.url}
                editable={false}
                deletable
                onClickDelete={(e) => { this._onClickRemove(e, idx, fields) }}
                imageClassName='fields-multi-image-upload__image'
                wrapperClassName='fields-multi-image-upload__image_wrapper'
                showDimension
                key={idx}
              />
            })}
            {(this.state.act !== RFMultiImageUpload.LOADING) && fields.length > 0 && fields.length < 5 &&
            <div className='fields-multi-image-upload__image_wrapper fields-image-preview__wrapper'>
              <img src={plus} className='fields-image-preview__image fields-multi-image-upload__image' onClick={this._onClickUpload} />
            </div>}
            {(this.state.act === RFMultiImageUpload.LOADING) && <div className='fields-multi-image-upload__image_wrapper fields-image-preview__wrapper'>
              <img src={loader} className='fields-image-preview__image fields-multi-image-upload__image' />
            </div>}
          </div>
        </div>
      </Dropzone>
      <SimpleInfoModal
        show={this.state.act === RFMultiImageUpload.SHOW_INFO_MODAL}
        content={this.state.infoModalContent}
        onClickConfirm={() => { this.setState({act: RFMultiImageUpload.WAIT_FOR_FILE}); mpOauthForm.uploadScreenshotFailed({step: '4', id: this.props.uid}) }}
      />
    </div>
  }

  _onClickUpload = () => {
    const {fields} = this.props
    let countImages = fields.length
    mpOauthForm.uploadScreenshot({step: '4', id: this.props.uid, countImages})
  }

  _onClickRemove = (e, idx, fields) => {
    e.stopPropagation()
    fields.remove(idx)
  }

  _onDrop = async (acceptedFiles) => {
    let maxSizeByte = 0
    const {maxSizeUnit, maxSize, fields, maxImages} = this.props
    const type = acceptedFiles[0].type
    let validateResolutionMessage = null

    if (maxSizeUnit === 'MB') {
      maxSizeByte = maxSize * 1024 * 1024
    } else {
      throw new Error('Not implemented')
    }
    if (type !== 'image/jpg' && type !== 'image/jpeg' && type !== 'image/png' && type !== 'image/gif') {
      this.setState({
        act: RFMultiImageUpload.SHOW_INFO_MODAL,
        infoModalContent: 'Please upload valid image'
      })
    } else if (fields.length >= maxImages) {
      this.setState({
        act: RFMultiImageUpload.SHOW_INFO_MODAL,
        infoModalContent: `Maximum ${maxImages} images can be uploaded`
      })
    } else if (acceptedFiles[0].size >= maxSizeByte) {
      this.setState({
        act: RFMultiImageUpload.SHOW_INFO_MODAL,
        infoModalContent: `File size must be less than ${maxSize} ${maxSizeUnit}`
      })
    } else if (validateResolutionMessage = await this._invalidImageResolution(acceptedFiles[0].preview)) {
      this.setState({
        act: RFMultiImageUpload.SHOW_INFO_MODAL,
        infoModalContent: validateResolutionMessage
      })
    } else {
      this.setState({
        act: RFMultiImageUpload.LOADING
      })
      this.uploadImage(acceptedFiles[0]).then((url) => {
        fields.push({
          image: {
            url
          }
        })
        this.setState({
          act: RFMultiImageUpload.WAIT_FOR_FILE
        })
        this._scrollImageContainerToRight()
      }).catch((error) => {
        this.setState({
          act: RFMultiImageUpload.WAIT_FOR_FILE
        })
      })
    }
  }

  uploadImage = async (file) => {
    let resUploadImage = await s3new({})
    const {data} = resUploadImage.data
    let formData = new FormData()
    formData.append('key', data.key)
    formData.append('acl', data.acl)
    formData.append('AWSAccessKeyId', data.aws_access_key_id)
    formData.append('success_action_status', data.success_action_status)
    formData.append('Content-Type', data.content_type)
    formData.append('Cache-Control', data.cache_control)
    formData.append('policy', data.policy)
    formData.append('signature', data.signature)
    formData.append('file', file)
    try {
      await axios.post(data.url, formData, {})
      return Promise.resolve(data.fullUrl)
    } catch (error) {
      return Promise.reject(false)
    } finally {
    }
  }

  // force image container to scroll right
  _scrollImageContainerToRight = () => {
    this._imageScrollableDOM.scrollLeft = this._imageScrollableDOM.scrollWidth - this._imageScrollableDOM.getBoundingClientRect().width
  }

  _invalidImageResolution = (url) => {
    return new Promise((resolve) => {
      let img = new Image();
      img.onload = () => {
        //if need validation of width and height
        if (this.props.resolutionExactWidth !== null && this.props.resolutionExactHeight !== null){
          if (img.width !== this.props.resolutionExactWidth || img.height !== this.props.resolutionExactHeight) {
            resolve(`Image resolution should be ${this.props.resolutionExactWidth}x${this.props.resolutionExactHeight}px`)
          } else {
            resolve(false)
          }

        } else {
          resolve(false)
        }
      }
      img.src = url;
    })
  }

  _screenshotUpload = () => {
    clevertap.event.push('Connect Create Screenshot Upload 1')
    mixpanel.track('Connect Step 4 Upload 1')
  }
}

RFMultiImageUpload.propTypes = {
  name: PropTypes.string,
  maxSize: PropTypes.number,
  maxSizeUnit: PropTypes.string,
  maxImages: PropTypes.number,
  dropzoneClassName: PropTypes.string,
  //specify this AND height if need validation of resolution
  resolutionExactWidth: PropTypes.number,
  //specify this AND width if need validation of resolution
  resolutionExactHeight: PropTypes.number
}

RFMultiImageUpload.defaultProps = {
  maxSize: 2,
  maxImages: 5,
  maxSizeUnit: 'MB',
  dropzoneClassName: '',
  resolutionExactWidth: null,
  resolutionExactHeight: null
}

export {RFMultiImageUpload}



// WEBPACK FOOTER //
// app/javascript/components/fields/MultiImageUpload/MultiImageUpload.js